import './css/dashboardtable.css';
import React, { useState,useEffect} from "react";
import axios from '../../config/index';
import { Link, useNavigate } from 'react-router-dom';
import Landing from '../Landing';




function AllCategories(){


        
    useEffect(() => {
        axios
    .get('session-admin')
    .then((res) => {
        if (res.data.valid) {

            if(res.data.type == "admin"){

            }else{
                navigate('/admin-login');
            }

        } else {

        }
    })
    .catch((err) => console.log(err));
    },[]);



    
    const navigate = useNavigate();
    const [AllCategories, setAllCategories] = useState([]);

    axios.defaults.withCredentials = true;





    const getAllCategories = ()=>{
        axios.post('AllItems', {
            table: 'categories',
        })
        .then((res) => {
            if (res.data) {
                console.log(res.data)
                setAllCategories(res.data);
            } else {
                console.log("Error happened");
            }
        })
        .catch((err) => console.log(err));
    };
    




    const getIfLogin= ()=>{
        
    axios
    .get('session')
    .then((res) => {
        if (!res.data.valid) {
            console.log(res.data.valid);
            navigate('/admin-login');

        }else{
            console.log(res.data.valid);

        }
    })
    .catch((err) => console.log(err));

    }





    const deleteItem = (id) => {
        axios
        .delete(`delete-item/${id}`, {
            data: {
            table: 'categories',
            },
        })
        .then((response) => {
            if (response.data.message === 'Item deleted successfully') {
                getAllCategories();
            } else {
            console.error('Failed to delete result:', response.data.message);
            }
        })
        .catch((error) => {
            console.error('Error deleting result:', error);
        });
    };




useEffect(() => {

    getAllCategories();
    getIfLogin();

}, []);




    

    return(
        <>
            <section className='dashboard'>



                <div className='results-table'>
                <Link className='new-item' to='/add-category'> +  New Category</Link>
                <table>

                    <thead>
                        <tr>
                            <th>ID</th>
                            <th> Name </th>


                            <th>Options</th>

                        </tr>
                    </thead>
                    <tbody>
                    {AllCategories.length ? (

                        AllCategories.map(cat => {

                        return (
                            <tr key={cat.id}>
                            <td><h6>{cat.id}</h6></td>

                            <td><h6>{cat.header}</h6></td>

                            <td>
                                <Link className='edit' to={`/edit-category?id=${cat.id}`}> <i class="las la-edit"></i> </Link>
                            </td>

                            
                            <td>
                                <button className='delete' onClick={() => deleteItem(cat.id)}> <i class="las la-trash-alt"></i> </button>
                            </td>

                            </tr>
                        );
                        })): 
                        
                        
                        
                        (
                            <tr>
                                <td colSpan={5}>Loading...</td>
                            </tr>
                            )}
                    </tbody>
                </table>

                </div>
            </section>
        
        </>
    )
}

export default AllCategories;